import React from 'react';
import { set } from 'lodash/fp';
import { sortBy, } from 'lodash';
import { toast } from 'react-toastify';

import firebase from '../../firebase';
import { colors, } from '../../shared/config';
import { canUpdateLectureType } from '../../shared/abilities';
import AdminPage from '../hocs/AdminPage';
import ModelFormModal from '../modals/ModelFormModal';
import useCollectionSubscriptionInTenant from '../hooks/useCollectionSubscriptionInTenant';
import AddInTenantButton from '../AddInTenantButton';
import EditButton from '../EditButton';
import DeleteButton from '../DeleteButton';
import { fields } from '../../shared/models/lectureType';

const db = firebase.firestore();
const productsRef = db.collection('products');
const lectureTypesRef = db.collection('lectureTypes');

export default AdminPage(function AdminLectureTypes (props) {
  const { user } = props;
  const lectureTypes = sortBy(useCollectionSubscriptionInTenant(lectureTypesRef), _ => _.createdAt.toDate());

  return (
    <div>
      <div className="admin-lectureTypes container py-5 position-relative">
        <div className="d-flex justify-content-center mb-3">
          <h4>レクチャー種別一覧</h4>
        </div>
        <div className="d-flex justify-content-end mb-3">
          <AddInTenantButton itemRef={lectureTypesRef.doc()} FormModal={ModelFormModal} formProps={{ title: 'レクチャー種別追加', fields, }} disabled={!canUpdateLectureType(user)} />
        </div>
        <div>
          {
            lectureTypes.length > 0 ? (
              <table className="table">
                <thead className="thead-light text-center">
                  <tr>
                    <th>名称</th>
                    <th>英語</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    lectureTypes.map((lectureType) => {
                      const { id, name, enName, ref, } = lectureType;
                      const beforeDelete = async () => {
                        if(
                          (await db.collectionGroup('lectures').where('lectureType', '==', id).limit(1).get()).docs.length > 0
                        ) {
                          toast.error('使用されているため削除できません');
                          return false;
                        }
                      };

                      return (
                        <tr key={id}>
                          <td>
                            {name}
                          </td>
                          <td>
                            {enName}
                          </td>
                          <td className="text-nowrap text-right">
                            <EditButton itemRef={ref} FormModal={ModelFormModal} formProps={{ title: 'レクチャー種別編集', fields }} disabled={!canUpdateLectureType(user)} />
                            <DeleteButton itemRef={ref} className="ml-2" disabled={!canUpdateLectureType(user)} beforeDelete={beforeDelete} />
                          </td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </table>
            ) : (
              <div>
                レクチャー種別は未登録です
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
});

